<template>
  <modal-wrapper :shown="shown" title="Add new email domain" @close-modal="$emit('close-modal')">
    <div class="m-5">
      <input v-model="domainName" type="text" placeholder="snappykraken.com" @keyup.enter="onEnterKeyUp" />
    </div>

    <button
      class="btn btn-warning btn-lg modal-action-button"
      :disabled="saveDisabled"
      type="button"
      @click="onCreateClick"
    >
      Save
    </button>

    <modal-processing-indicator v-if="processing"></modal-processing-indicator>

    <div v-if="errorMessage" v-html="errorMessage" class="text-danger mt-5"></div>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '../../modal/ModalWrapper';
import ModalProcessingIndicator from '../../modal/ModalProcessingIndicator';
import {handleActionModalResponse} from '../../../utility/modal/handleActionModalResponse';
import {createEmailDomain} from '../../../utility/api/vessel/createEmailDomain';

export default {
  name: 'add-email-domain-modal',
  components: {ModalWrapper, ModalProcessingIndicator},
  data() {
    return {
      domainName: '',
      errorMessage: null,
      processing: false,
    };
  },
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    shown(shown, previousShown) {
      if (!shown && previousShown) {
        this.processing = false;
        this.domainName = '';
      }
    },
    domainName() {
      this.errorMessage = null;
    },
  },
  computed: {
    domainNameValid() {
      return /^[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(this.domainName);
    },
    saveDisabled() {
      return this.processing || !this.domainNameValid || this.errorMessage;
    },
  },
  methods: {
    onCreateClick() {
      this.createDomain();
    },
    onEnterKeyUp() {
      this.createDomain();
    },
    async createDomain() {
      if (this.saveDisabled) {
        return;
      }

      this.processing = true;
      try {
        const response = await createEmailDomain(this.domainName);
        if (handleActionModalResponse(response, `/account/mailer/?domain=${response.id}`)) {
          this.$emit('close-modal');
        }
      } catch (error) {
        if (error.code === 422) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage = 'Failed to add new email domain!';
        }
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  background: #fff;
  border: 0;
  border-radius: 5px;
  color: #555;
  font: 22px/34px 'Roboto Condensed' !important;
  height: 50px;
  width: 300px;

  &::placeholder {
    color: #999;
  }
}
</style>
